module.exports = __webpack_public_path__ + "static/axosoft-26fcdde83dc23fca54a3fcde458002e0.png";